import { render, staticRenderFns } from "./CalendarWeekView.vue?vue&type=template&id=0f5fb235&scoped=true"
import script from "./CalendarWeekView.vue?vue&type=script&lang=js"
export * from "./CalendarWeekView.vue?vue&type=script&lang=js"
import style0 from "./CalendarWeekView.vue?vue&type=style&index=0&id=0f5fb235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5fb235",
  null
  
)

export default component.exports